import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {TreatmentDefinitionModel} from '../treatmentDefinitionModel';
import {TreatmentDefinitionSummaryConverter} from './treatmentDefinitionSummary.converter';
import {
    FormDefinitionFormConverter
} from '../../../../../../form/definition/form/api/entity/converter/formDefinitionForm.converter';

@Injectable({
    providedIn: 'root'
})
export class TreatmentDefinitionConverter extends HttpModelConverter<TreatmentDefinitionModel> {

    constructor(private treatmentDefinitionSummaryConverter: TreatmentDefinitionSummaryConverter,
                private formDefinitionFormConverter: FormDefinitionFormConverter) {
        super();
    }

    protected createInstance(): TreatmentDefinitionModel {
        return new TreatmentDefinitionModel();
    }

    protected enrichObject(result: TreatmentDefinitionModel, src: TreatmentDefinitionModel) {
        result.summary = this.treatmentDefinitionSummaryConverter.convert(src.summary);
        result.formDefinition = this.formDefinitionFormConverter.convert(src.formDefinition);
    }

}
